// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarVehiclesSection_container__Y1XTn"};